import {
    useObtenerGridDepartamentosRRHHDashboard,
    //useObtenerGridEmpleadosRRHHDashboard,
    useBuscarDepartamentosAutoComplete, exportarDepartamentosGrid,
    //useBuscarEmpleadosAutoComplete 
} from "../../Scripts/Service/rrhh-dashboard-service.js";
  import {
    AutoComplete,
    SelectButton,
    Dropdown,
    addLocale,
    Button,
    Column,
    DataTable,
    Calendar,
    ProgressSpinner,
    FilterMatchMode,
    FilterOperator,
    InputNumber,
    locale,
    Message,
    Row,
    ColumnGroup,
  } from 'primereact';
import React, {useState} from "react";
import {createPortal} from "react-dom";
import Exportar from "../../../Commons/Scripts/Componentes/Exportar/Exportar";
import ToolTip from "../../../Commons/Scripts/Componentes/ToolTip/Tooltip";
import {SvgComponent} from "../../../Commons/Scripts/Componentes";
import { Dropdown as Dp, Nav } from 'react-bootstrap';
import {useTheme} from "../../../Commons/Scripts/Hooks";
export const GridRRHH = () => {
    addLocale("es", {
        firstDayOfWeek: 1,
        showMonthAfterYear: true,
        dayNames: [
          "domingo",
          "lunes",
          "martes",
          "mi?rcoles",
          "jueves",
          "viernes",
          "s?bado",
        ],
        dayNamesShort: ["dom", "lun", "mar", "mi?", "jue", "vie", "s?b"],
        dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
        monthNames: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        monthNamesShort: [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic",
        ],
        today: "Hoy",
        clear: "Limpiar",
        equals: "Igual a",
        notEquals: "Diferente a",
        lt: "Menor a",
        lte: "Menor o igual a",
        gt: "Mayor a ",
        gte: "Mayor o igual a",
        is: "Is",
        isNot: "Is Not",
        before: "Before",
        after: "After",
        apply: "Aplicar",
        matchAll: "Coincidir todo",
        matchAny: "Coincidir cualquiera",
        addRule: "Agregar condicion",
        removeRule: "Quitar condicion",
      });
    const monedaPredeterminada = window.monedaPredeterminada;
    const {theme} = useTheme();
    const [showExportar, setShowExportar] = useState(false);
    const colorPrimario = window.colorPrimario;
    const [fechasGrid, setFechasGrid] = React.useState(null);
    // tabla
    const [departamentos, setTiendas] = React.useState([]);
    const [periodoGrid, setPeriodoGrid] = React.useState("mensual");
    const [filtros, setFiltros] = React.useState(null);
    const [cargandoData, setCargandoGrid] = React.useState(true);
    const [gridWhere, setGridWhere] = React.useState({
      where: {
        EsAscendente: false,
        EsOrdernable: true,
        OrderBy: "CostoSalario",
        IndiceDePagina: 0,
        esFecha: false,
        periodo: periodoGrid,
        DepartamentoNombreList: departamentos,
      },
    });
    const { data: departamentoGrid, error: errorDepartamentoGrid } =
    useObtenerGridDepartamentosRRHHDashboard(gridWhere);
    const [totalRecords, setTotalRecords] = React.useState(0);
    const [lazyState, setlazyState] = React.useState({
      first: 0,
      rows: 10,
      page: 0,
      sortField: "CostoSalario",
      sortOrder: -1,
      filters: filtros,
    });
    const onPage = (event) => {
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: fechasGrid?.[0] ?? null,
          fechaFin: fechasGrid?.[1] ?? null,
          IndiceDePagina: event.page,
        },
      };
      setGridWhere(newWhere);
      setlazyState(event);
      setCargandoGrid(true);
    };
    const onSort = (event) => {
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: fechasGrid?.[0] ?? null,
          fechaFin: fechasGrid?.[1] ?? null,
          EsAscendente: event.sortOrder == 1,
          OrderBy: event.sortField,
        },
      };
      setGridWhere(newWhere);
      setlazyState(event);
      setCargandoGrid(true);
    };
    const onFilter = (event) => {
      const filtros = event.filters;
      setlazyState(event);
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: fechasGrid?.[0] ?? null,
          fechaFin: fechasGrid?.[1] ?? null,
          DepartamentoNombreList: filtros.Nombre.value,
          CostoSalarioFiltros: filtros.CostoSalario.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          CantidadEmpleadosFiltros: filtros.CantidadEmpleados.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          CostoSalarioPromedioFiltros: filtros.CostoSalarioPromedio.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          CostoAumentoSalarialFiltros: filtros.CostoAumentoSalarial.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          CantidadSalariosAumentadosFiltros: filtros.CantidadSalariosAumentados.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          PromedioAumentoSalarioFiltros: filtros.PromedioAumentoSalario.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          SalarioMasAltoFiltros: filtros.SalarioMasAlto.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          SalarioMasBajoFiltros: filtros.SalarioMasBajo.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          RatioMujerHombreFiltros: filtros.RatioMujerHombre.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          TotalPermisosHorasFiltros: filtros.TotalPermisosHoras.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          CostoPermisosFiltros: filtros.CostoPermisos.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          TotalAusenciasDiasFiltros: filtros.TotalAusenciasDias.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          CostoAusenciasFiltros: filtros.CostoAusencias.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          TotalLicenciasDiasFiltros: filtros.TotalLicenciasDias.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          CostoLicenciasFiltros: filtros.CostoLicencias.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          TotalHorasExtraFiltros: filtros.TotalHorasExtra.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          CostoHorasExtraFiltros: filtros.CostoHorasExtra.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          TotalPrestamosFiltros: filtros.TotalPrestamos.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          PromedioPrestamoFiltros: filtros.PromedioPrestamo.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          TasaDespidosFiltros: filtros.TasaDespidos.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          TasaRotacionEmpleadoFiltros: filtros.TasaRotacionEmpleado.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
        },
      };
      setGridWhere(newWhere);
      setCargandoGrid(true);
    };
    const borrarFiltros = () => {
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: fechasGrid?.[0] ?? null,
          fechaFin: fechasGrid?.[1] ?? null,
          DepartamentoNombreList: null,
          CostoSalarioFiltros: null,
          CantidadEmpleadosFiltros: null,
          CostoSalarioPromedioFiltros: null,
          CostoAumentoSalarialFiltros: null,
          CantidadSalariosAumentadosFiltros: null,
          PromedioAumentoSalarioFiltros: null,
          SalarioMasAltoFiltros: null,
          SalarioMasBajoFiltros: null,
          RatioMujerHombreFiltros: null,
          TotalPermisosHorasFiltros: null,
          CostoPermisosFiltros: null,
          TotalAusenciasDiasFiltros: null,
          CostoAusenciasFiltros: null,
          TotalLicenciasDiasFiltros: null,
          CostoLicenciasFiltros: null,
          TotalHorasExtraFiltros: null,
          CostoHorasExtraFiltros: null,
          TotalPrestamosFiltros: null,
          PromedioPrestamoFiltros: null,
          TasaDespidosFiltros: null,
          TasaRotacionEmpleadoFiltros: null,
        },
      };
      setGridWhere(newWhere);
      setCargandoGrid(true);
      initFiltros();
    };
    const initFiltros = () => {
      setFiltros({
        CantidadEmpleados: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        CostoSalario: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        CostoSalarioPromedio: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        CostoAumentoSalarial: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        CantidadSalariosAumentados: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        PromedioAumentoSalario: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        SalarioMasAlto: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        SalarioMasBajo: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        RatioMujerHombre: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        TotalPermisosHoras: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        CostoPermisos: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        TotalAusenciasDias: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        CostoAusencias: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        TotalLicenciasDias: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        CostoLicencias: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        TotalHorasExtra: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        CostoHorasExtra: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        TotalPrestamos: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        PromedioPrestamo: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        TasaDespidos: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        TasaRotacionEmpleado: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        Nombre: {
          value: null,
          matchMode: FilterMatchMode.IN,
        },
      });
    };
    const formatearBeneficioMasBajo = (rowData) => {
      return formatearMonto(rowData.BeneficioMasBajo);
    };
    const formatearBeneficioMasAlto = (rowData) => {
      return formatearMonto(rowData.BeneficioMasAlto);
    };
    const formatearBeneficioPromedio = (rowData) => {
      return formatearMonto(rowData.BeneficioPromedio);
    };
    const formatearTotalBeneficios = (rowData) => {
      return formatearMonto(rowData.TotalBeneficios);
    };
      const formatearCostoSalario = (rowData) => {
        return formatearMonto(rowData.CostoSalario);
      };
      const formatearCostoSalarioPromedio = (rowData) => {
        return formatearMonto(rowData.CostoSalarioPromedio);
      };
      const formatearCostoAumentoSalarial = (rowData) => {
        return formatearMonto(rowData.CostoAumentoSalarial);
      };
      const formatearPromedioAumentoSalario = (rowData) => {
        return formatearMonto(rowData.PromedioAumentoSalario);
      };
      const formatearSalarioMasAlto = (rowData) => {
        return formatearMonto(rowData.SalarioMasAlto);
      };
      const formatearSalarioMasBajo = (rowData) => {
        return formatearMonto(rowData.SalarioMasBajo);
      };
      const formatearCostoPermisos = (rowData) => {
        return formatearMonto(rowData.CostoPermisos);
      };
      const formatearCostoAusencias = (rowData) => {
        return formatearMonto(rowData.CostoAusencias);
      };
      const formatearCostoLicencias = (rowData) => {
        return formatearMonto(rowData.CostoLicencias);
      };
      const formatearCostoHorasExtra = (rowData) => {
        return formatearMonto(rowData.CostoHorasExtra);
      };
      const formatearTotalPrestamos = (rowData) => {
        return formatearMonto(rowData.TotalPrestamos);
      };
      const formatearPromedioPrestamo = (rowData) => {
        return formatearMonto(rowData.PromedioPrestamo);
      };
      const formatearTasaDespidos = (rowData) => {
        return formatearTasa(rowData.TasaDespidos);
      };
      const formatearTasaRotacionEmpleado = (rowData) => {
        return formatearTasa(rowData.TasaRotacionEmpleado);
      };
      const formatearCantidadEmpleados = (rowData) => {
        return formatearCantidad(rowData.CantidadEmpleados)
      }
      const formatearCantidadSalariosAumentados = (rowData) => {
        return formatearCantidad(rowData.CantidadSalariosAumentados)
      }
      const formatearTotalPermisosHoras = (rowData) => {
        return `${formatearCantidad(rowData.TotalPermisosHoras)} hora(s)`
      }
      const formatearTotalAusenciasDias = (rowData) => {
        return `${formatearCantidad(rowData.TotalAusenciasDias)} dia(s)`
      }
      const formatearTotalLicenciasDias = (rowData) => {
        return `${formatearCantidad(rowData.TotalLicenciasDias)} dia(s)`
      }
      const formatearTotalHorasExtra = (rowData) => {
        return `${formatearCantidad(rowData.TotalHorasExtra)} hora(s)`
      }
    const formatearTasa = (value) => {
        value = value ?? 0.00;
        return `${value.toFixed(2)}%`;
      };
    const formatearCantidad = (value) => {
        value = value ?? 0.00;
        return `${Citrus.Convert.toCurrencyNoSimbolo(value)}`;
      };

      const formatearMonto = (value) => {
        value = value ?? 0.00;
        return `${monedaPredeterminada} ${Citrus.Convert.toCurrencyNoSimbolo(value)}`;
      };
    const tasasFiltroTemplate = (options) => {
      return (
        <InputNumber
          value={options.value}
          onChange={(e) => options.filterCallback(e.value, options.index)}
          suffix="%"
        />
      );
    };
    const montosFiltroTemplate = (options) => {
      return (
        <InputNumber
          value={options.value}
          onChange={(e) => options.filterCallback(e.value, options.index)}
          locale="en-US" minFractionDigits={2}
          prefix={monedaPredeterminada}
        />
      );
    };
    const DepartamentoFiltroTemplate = (options) => {
      return (
        <AutoComplete
          pt={{
            panel: { style: { width: "400px" } },
          }}
          onClick={(e) => autoCompleteRef.current.search(e, "", "dropdown")}
          ref={autoCompleteRef}
          emptyMessage="No hay resultados disponibles"
          showEmptyMessage="true"
          inputId="ac"
          value={options.value}
          multiple
          suggestions={dataFiltrada}
          completeMethod={buscarDepartamentos}
          placeholder="Buscar Departamentos"
          onChange={(e) => options.filterCallback(e.value)}
          style={{ width: "400px" }}
        />
      );
    };
    //multiLookup
    const autoCompleteRef = React.useRef(null);
    const [where, setWhere] = React.useState({ where: {} });
    const { data } = useBuscarDepartamentosAutoComplete(where);
    const [dataFiltrada, setDataFiltrada] = React.useState(null);
    const [cargando, setCargando] = React.useState(true);
    const buscarDepartamentos = (event) => {
      setWhere({ where: { Criterio: event.query, CantidadPorPagina: 1000 } });
    };
  
    //filtro periodos
    const [periodo, setPeriodo] = React.useState(1);
    const periodos = [
      { name: "Actual", value: 1 },
      { name: "Anterior", value: 2 },
      { name: "Otro", value: 3 },
    ];
    const [value, setValue] = React.useState(3);
    const [periodosPredifinidos, setPeriodosPredifinidos] = React.useState([]);
    const actual = [
      { name: "Hoy", value: 1 },
      { name: "Esta Semana", value: 2 },
      { name: "Este Mes", value: 3 },
      { name: "Este Trimestre", value: 4 },
      { name: "Este Año", value: 5 },
    ];
    const anterior = [
      { name: "Ayer", value: 6 },
      { name: "Semana Anterior", value: 7 },
      { name: "Mes Anterior", value: 8 },
      { name: "Trimestre Anterior", value: 9 },
      { name: "Año Anterior", value: 10 },
    ];
    function handleChange(value) {
      setValue(value);
      setCargandoGrid(true);
      let periodo;
      switch (value) {
        case 1:
          periodo = "diario";
          break;
        case 2:
          periodo = "semanal";
          break;
        case 3:
          periodo = "mensual";
          break;
        case 4:
          periodo = "trimestral";
          break;
        case 5:
          periodo = "anual";
          break;
        case 6:
          periodo = "ayer";
          break;
        case 7:
          periodo = "semana anterior";
          break;
        case 8:
          periodo = "mes anterior";
          break;
        case 9:
          periodo = "trimestre anterior";
          break;
        case 10:
          periodo = "ano anterior";
          break;
      }
      setPeriodoGrid(periodo);
      const newWhere = {
        where: {
          ...gridWhere.where,
          periodo: periodo,
          esFecha: false,
        },
      };
      setGridWhere(newWhere);
    }
    const [dates, setDates] = React.useState(null);
    let today = new Date();
    const [verRangoDeFechas, setVerRangoDeFechas] = React.useState(false);
  
    function setFechas() {
      setValue(null);
      const fechasFormateadas = dates.map((date) => formatDate(date));
      setFechasGrid(fechasFormateadas);
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: formatDate(dates[0]),
          fechaFin: formatDate(dates[1]),
          esFecha: true,
        },
      };
      setGridWhere(newWhere);
      setCargandoGrid(true);
    }
    function formatDate(date) {
      var date = new Date(date);
      var day = date.getDate();
      var month = date.getMonth() + 1;
      var year = date.getFullYear();
      return day + "/" + month + "/" + year;
    }
    const matchModes = [
      {
        label: "Mayor o igual a",
        value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
      },
      { label: "Menor o igual a", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    ];
    const header = () => {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="p-component">
            <Button
              type="button"
              icon="pi pi-filter-slash"
              label="Limpiar Filtros"
              outlined
              onClick={borrarFiltros}
              id="quitarFiltros"
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              flexDirection: "column",
              alignItems: "center",
              minWidth: "50%",
            }}
          >
            <div style={{ width: "40%", marginBottom: "5px" }}>
              <Dropdown
                value={periodo}
                onChange={(e) => setPeriodo(e.value)}
                options={periodos}
                optionLabel="name"
              />
            </div>
  
            {verRangoDeFechas ? (
              <div>
                <Calendar
                  maxDate={today}
                  placeholder="Rango de Fechas"
                  dateFormat="dd/mm/yy"
                  value={dates}
                  selectionMode="range"
                  locale="es"
                  onChange={(e) => setDates(e.value)}
                />
              </div>
            ) : (
              <SelectButton
                value={value}
                onChange={(e) => handleChange(e.value)}
                optionLabel="name"
                options={periodosPredifinidos}
              />
            )}
          </div>
            <div>
                <Dp as={Nav.Item}>
                    <Dp.Toggle
                        as={Nav.Link}
                        id="Dp-company-switch"
                        className="buttonHover"
                        onClick={openExportar}
                    >
                        <ToolTip placement="left" message="Exportar">
                            <SvgComponent
                                iconName="export"
                                fill={theme.color1}
                            />
                        </ToolTip>
                    </Dp.Toggle>
                </Dp>
            </div>
            
        </div>
      );
    };
    const colmunas = [
      {
        field: "CostoSalario",
        header: "Costo de Salario",
        dataType: "numeric",
        filterElement: montosFiltroTemplate,
        body: formatearCostoSalario
      },
      {
        field: "TotalBeneficios",
        header: "Costo de Beneficios",
        dataType: "numeric",
        filterElement: montosFiltroTemplate,
        body: formatearTotalBeneficios
      },
      {
        field: "CantidadEmpleados",
        header: "Cantidad de Empleados",
        dataType: "string",
        body: formatearCantidadEmpleados
      },
      {
        field: "CostoSalarioPromedio",
        header: "Costo de Salario Promedio",
        dataType: "numeric",
        filterElement: montosFiltroTemplate,
        body: formatearCostoSalarioPromedio
      },
      {
        field: "BeneficioPromedio",
        header: "Costo de Beneficio Promedio",
        dataType: "numeric",
        filterElement: montosFiltroTemplate,
        body: formatearBeneficioPromedio
      },
      {
        field: "SalarioMasAlto",
        header: "Salario mas Alto",
        dataType: "numeric",
        filterElement: montosFiltroTemplate,
        body: formatearSalarioMasAlto
      },
      {
        field: "SalarioMasBajo",
        header: "Salario mas Bajo",
        dataType: "numeric",
        filterElement: montosFiltroTemplate,
        body: formatearSalarioMasBajo
      },
      {
        field: "BeneficioMasAlto",
        header: "Beneficio mas Alto",
        dataType: "numeric",
        filterElement: montosFiltroTemplate,
        body: formatearBeneficioMasAlto
      },
      {
        field: "BeneficioMasBajo",
        header: "Beneficio mas Bajo",
        dataType: "numeric",
        filterElement: montosFiltroTemplate,
        body: formatearBeneficioMasBajo
      },
      {
        field: "CostoAumentoSalarial",
        header: "Costo de Aumento Salarial",
        dataType: "numeric",
        filterElement: montosFiltroTemplate,
        body: formatearCostoAumentoSalarial
      },
      {
        field: "CantidadSalariosAumentados",
        header: "Cantidad de Salarios Aumentados",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,     
        body: formatearCantidadSalariosAumentados
      },
      {
        field: "PromedioAumentoSalario",
        header: "Promedio de Aumento de Salario",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearPromedioAumentoSalario
      },
      {
        field: "RatioMujerHombre",
        header: "Ratio de Mujer/Hombre",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
      },
      {
        field: "TotalPermisosHoras",
        header: "Total de Permisos(horas)",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearTotalPermisosHoras
      },
      {
        field: "CostoPermisos",
        header: "Costo de Permisos",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearCostoPermisos
      },
      {
        field: "TotalAusenciasDias",
        header: "Total de Ausencias(dias)",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearTotalAusenciasDias
      },
      {
        field: "CostoAusencias",
        header: "Costo de Ausencias",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearCostoAusencias
      },
      {
        field: "TotalLicenciasDias",
        header: "Total Licencias(dias)",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearTotalLicenciasDias
      },
      {
        field: "CostoLicencias",
        header: "Costo de Licencias",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearCostoLicencias
      },
      {
        field: "TotalHorasExtra",
        header: "Total de Horas Extras",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearTotalHorasExtra
      },
      {
        field: "CostoHorasExtra",
        header: "Costo de Horas Extras",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearCostoHorasExtra
      },
      {
        field: "TotalPrestamos",
        header: "Total de Prestamos",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearTotalPrestamos
      },
      {
        field: "PromedioPrestamo",
        header: "Promedio Prestamo",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearPromedioPrestamo
      },
      {
        field: "TasaDespidos",
        header: "Tasa de Despidos",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearTasaDespidos
      },
      {
        field: "TasaRotacionEmpleado",
        header: "Tasa de Rotacion de Empleado",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearTasaRotacionEmpleado
      },
    ];
    const openExportar = () => {
        setShowExportar(true);
    };
    // useEffect
    React.useEffect(() => {
      locale("es");
      initFiltros();
    }, []);
    React.useEffect(() => {
      if (data) {
        let _departamentosFiltrados = [];
        _departamentosFiltrados = data.Resultados.map((e) => {
          return e.text;
        });
        setDataFiltrada(_departamentosFiltrados);
      }
    }, [data]);
    React.useEffect(() => {
      if (departamentoGrid && !errorDepartamentoGrid) {
        setTotalRecords(departamentoGrid.total);
        setCargando(false);
        setCargandoGrid(false);
      } else if (departamentoGrid) {
        setTotalRecords(departamentoGrid.total);
        setCargando(false);
        setCargandoGrid(false);
      }
      setCargandoGrid(false);

    }, [departamentoGrid]);
    React.useEffect(() => {
      if (dates) {
        if (dates[0] !== null && dates[1] !== null) {
          setFechas();
        }
      }
    }, [dates]);
    React.useEffect(() => {
      if (periodo == 1) {
        setPeriodosPredifinidos(actual);
        setVerRangoDeFechas(false);
      } else if (periodo == 2) {
        setPeriodosPredifinidos(anterior);
        setVerRangoDeFechas(false);
      } else {
        setVerRangoDeFechas(true);
      }
    }, [periodo]);
    React.useEffect(() => {
      setlazyState({
        ...lazyState,
        filters: filtros,
      });
    }, [filtros]);
  
    return (
      <div className="new-p-table">
        {cargando ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ProgressSpinner />
          </div>
        ) : (
          <>
              {showExportar && createPortal(
                  <Exportar
                      PROPIEDADES_EXPORTAR={[
                          {value: 'IdSec', label: 'Id'},
                          {value: 'Nombre', label: 'Nombre'},
                          {value: 'CostoSalario', label: 'Costo de Salario'},
                          {value: 'TotalBeneficios', label: 'Costo de Beneficios'},
                          {value: 'CantidadEmpleados', label: 'Cantidad de Empleados'},
                          {value: 'CostoSalarioPromedio', label: 'Costo de Salario Promedio'},
                          {value: 'BeneficioPromedio', label: 'Costo de Beneficio Promedio'},
                          {value: 'SalarioMasAlto', label: 'Salario mas Alto'},
                          {value: 'SalarioMasBajo', label: 'Salario mas Bajo'},
                          {value: 'BeneficioMasAlto', label: 'Beneficio mas Alto'},
                          {value: 'BeneficioMasBajo', label: 'Beneficio mas Bajo'},
                          {value: 'CostoAumentoSalarial', label: 'Costo de Aumento Salarial'},
                          {value: 'CantidadSalariosAumentados', label: 'Cantidad de Salarios Aumentados'},
                          {value: 'PromedioAumentoSalario', label: 'Promedio de Aumento de Salario'},
                          {value: 'RatioMujerHombre', label: 'Ratio de Mujer/Hombre'},
                          {value: 'TotalPermisosHoras', label: 'Total de Permisos(horas)'},
                          {value: 'CostoPermisos', label: 'Costo de Permisos'},
                          {value: 'TotalAusenciasDias', label: 'Total de Ausencias(dias)'},
                          {value: 'CostoAusencias', label: 'Costo de Ausencias'},
                          {value: 'TotalLicenciasDias', label: 'Total Licencias(dias)'},
                          {value: 'CostoLicencias', label: 'Costo de Licencias'},
                          {value: 'TotalHorasExtra', label: 'Total de Horas Extras'},
                          {value: 'CostoHorasExtra', label: 'Costo de Horas Extras'},
                          {value: 'TotalPrestamos', label: 'Total de Prestamos'},
                          {value: 'PromedioPrestamo', label: 'Promedio Prestamo'},
                          {value: 'TasaDespidos', label: 'Tasa de Despidos'},
                          {value: 'TasaRotacionEmpleado', label: 'Tasa de Rotacion de Empleado'},
                      ]}
                      where={{...gridWhere.where}}
                      showExportar={showExportar}
                      setShowExportar={setShowExportar}
                      exportarCallBack={exportarDepartamentosGrid}
                  >
                  </Exportar>,
                  window.parent.document.querySelector("#sidebarContainer")
              )}
            <div>
              {errorDepartamentoGrid && (
                <Message
                  severity="warn"
                  text={errorDepartamentoGrid?.Mensaje}
                  style={{ width: "100%", marginBottom: "10px" }}
                />
              )}
            </div>
            <DataTable
              showGridlines
              header={header}
              onFilter={onFilter}
              filters={lazyState.filters}
              value={departamentoGrid.departamentos}
              lazy
              first={lazyState.first}
              rows={25}
              loading={cargandoData}
              paginator
              totalRecords={totalRecords}
              onPage={onPage}
              onSort={onSort}
              sortField={lazyState.sortField}
              sortOrder={lazyState.sortOrder}
              tableStyle={{ minWidth: "50rem" }}
              stripedRows
              size="small"
              emptyMessage="No hay resultados disponibles."
              resizableColumns
              columnResizeMode="expand"
              pt={{
                paginator: {
                  pageButton: "p-component",
                  nextPageButton: "p-component",
                  lastPageButton: "p-component",
                  prevPageButton: "p-component",
                  firstPageButton: "p-component",
                },
              }}
            >
          <Column
            style={{ textAlign: "right" }}
            sortable
            field="IdSec"
            header="ID"
          />
          <Column
            style={{ minWidth: "15rem" }}
            sortable
            field="Nombre"
            header="Departamento"
            showFilterMatchModes={false}
            filter
            filterField="Nombre"
            filterElement={DepartamentoFiltroTemplate}
            pt={{
              filterMenuButton: { className: "p-component" },
              filterButtonbar: { className: "test" },
            }}
          />
          {colmunas.map((col, i) => (
            <Column
              style={{ minWidth: "5rem", textAlign:"right" }}
              pt={{
                filterMenuButton: { className: "p-component" },
                filterButtonbar: { className: "test" },
              }}
              sortable
              field={col.field}
              header={col.header}
              body={col.body}
              filter
              sortField={col.field}
              filterField={col.field}
              filterElement={col.filterElement}
              dataType={col.dataType}
              showFilterOperator={false}
              filterMatchModeOptions={matchModes}
            />
          ))}
            </DataTable>
          </>
        )}
      </div>
    );
  };